import type { MultiPrimaryItem } from '@/components/Form/FormAutocompleteField/MultiPrimaryAutocompleteField';

export const mapDegreesIn = (
	primary: string | null | undefined,
	others: string | null | undefined
): MultiPrimaryItem[] => {
	if ((!primary && !others) || !primary || primary?.length === 0) return [];

	const otherArray = others ? others.split(',').map(o => o.trim()) : [];
	const all = [
		...(primary ? [{ id: primary, name: primary, isPrimary: true }] : []),
		...otherArray.map(v => ({ id: v, name: v, isPrimary: false }))
	];
	return Array.from(new Map(all.map(a => [a.id, a])).values());
};
